import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=3ec85188&scoped=true"
import script from "./chat.ts?vue&type=script&lang=ts&external"
export * from "./chat.ts?vue&type=script&lang=ts&external"
import style0 from "./chat.scss?vue&type=style&index=0&id=3ec85188&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec85188",
  null
  
)

export default component.exports